import React, { useEffect, useState } from "react";
import "./ReportCyberCrime.css";
import Dynamicbanner from "../../include/DynamicBanner";
import api from "../../../../api";


const toArray = (val) => {
  if (!val) return [];
  if (Array.isArray(val)) return val;
  if (typeof val === "object") return Object.values(val);
  return [val];
};

const ReportCyberCrime = () => {
const [banner, setBanner] = useState({
  title: "",
  images: [],
  mobile_images: [],
});

  const [rscData, setRscData] = useState({
    heading: "Report Cyber Crime Online",
    content: "",
    button_text: "Visit Cyber Crime Portal",
    button_url: "https://cybercrime.gov.in",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await api.get("/api/sitepages/about-us/report-cyber-crime");
        const data = res.data || {};

        const bannerData = data.banner_data || {};
       const normalizedBanner = {
  title: bannerData.title || bannerData.heading || "",
  images: toArray(bannerData.images),
  mobile_images: toArray(bannerData.mobile_images),
};


        const rd = data.rsc_data || {};
        const normalizedRsc = {
          heading: rd.heading || "Report Cyber Crime Online",
          content: rd.content || "",
          button_text: rd.button_text || "Visit Cyber Crime Portal",
          button_url: rd.button_url || "https://cybercrime.gov.in",
        };

        if (!cancelled) {
          setBanner(normalizedBanner);
          setRscData(normalizedRsc);
          setError(null);
        }
      } catch (err) {
        console.error("Error fetching Report Cyber Crime data:", err);
        if (!cancelled) setError("Failed to load content.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchData();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading || error) {
    return null;
  }

  return (
    <>
      <Dynamicbanner
  title={banner.title}
  bgImage={banner.images}
  bgImageMobile={banner.mobile_images}
/>


      <section className="pb_80">
        <div className="container">
          <div className="sec-title text-center">
            <h2>{rscData.heading}</h2>
          </div>

          <div className="row justify-content-center">
            <div className="col-md-10 col-lg-8">
              <div className="shadow-lg p-4 cyber-report-box">
                <div className="cyber-icon">
                  <i className="fa fa-shield"></i>
                </div>
                <div className="cyber-report-body">
                  <div
                    dangerouslySetInnerHTML={{ __html: rscData.content }}
                  />
                  <a
                    href={rscData.button_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn click mt-3"
                  >
                    <i className="fa fa-external-link me-2"></i>
                    {rscData.button_text}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ReportCyberCrime;
